import { RefObject, useEffect, useRef, useState } from 'react'
import { useSpeechInput } from 'components/Setup/SetupModal/hooks/useSpeechInput'

interface IOptions {
  text: string
  onChange: (text: string) => void
  active: boolean
  input: RefObject<HTMLTextAreaElement>
}
export function useChatDictation({ text, onChange, active, input }: IOptions) {
  const speech = useSpeechInput({ value: text, onChange, isOpen: active })
  const original = useRef('')
  const wasListening = useRef(false)
  const [seconds, setSeconds] = useState(0)
  useEffect(() => {
    if (active && wasListening.current && !speech.listening) input.current?.focus({ preventScroll: true })
    wasListening.current = speech.listening
  }, [active, speech.listening, input])
  useEffect(() => {
    if (!speech.listening) return
    setSeconds(0)
    const startedAt = Date.now()
    const timer = window.setInterval(() => setSeconds(Math.floor((Date.now() - startedAt) / 1000)), 1000)
    return () => window.clearInterval(timer)
  }, [speech.listening])
  return {
    speech,
    seconds,
    original: original.current,
    start: () => {
      original.current = text
      void speech.startListening()
    },
    cancel: () => {
      speech.cleanup()
      onChange(original.current)
    },
  }
}
